import { Col, InputGroup, Label, Row } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Btn } from "../../../../../AbstractElements";
import { ConveyanceFilterBarProps } from "../../../types";
import IconComponent from "../../../../../CommonElements/IconComponent";

const ConveyanceFilterBar: React.FC<ConveyanceFilterBarProps> = ({
  location,
  byPassRole,
  isSameLoginId,
  endDate,
  startDate,
  SearchLabel,
  EndDateLabel,
  StartDateLabel,
  AddConveyanceLabel,
  isConveyanceListLoading,
  submit = "button",
  primary = "primary",
  handleSearch,
  handleChangeStartDate,
  handleChangeEndDate,
  handleAddConveyance,
}) => {
  const onEmployeeConveyance = location.pathname.includes(
    "/employee-zone/conveyance"
  );
  const shouldShowAddBtn =
    onEmployeeConveyance ||
    (byPassRole && !onEmployeeConveyance) ||
    (!onEmployeeConveyance && isSameLoginId);

  return (
    <Row className="align-items-center">
      <Col xs="6" md="3">
        <InputGroup className="flatpicker-calender">
          <Label className="col-form-label">{StartDateLabel}</Label>
          <ReactDatePicker
            className="form-control flatpickr-input f-14"
            selected={startDate}
            onChange={(date: Date) => handleChangeStartDate(date)}
          />
        </InputGroup>
      </Col>
      <Col xs="6" md="3">
        <InputGroup className="flatpicker-calender">
          <Label className="col-form-label">{EndDateLabel}</Label>
          <ReactDatePicker
            className="form-control flatpickr-input f-14"
            selected={endDate}
            onChange={(date: Date) => handleChangeEndDate(date)}
          />
        </InputGroup>
      </Col>
      <Col
        xs="4"
        md={onEmployeeConveyance ? 3 : 2}
        lg="2"
        className="mt-md-2 text-md-end text-lg-start"
      >
        <Btn
          type={submit}
          className="mt-3 mt-md-4 f-12 w-100"
          color={primary}
          onClick={handleSearch}
          disabled={isConveyanceListLoading}
        >
          {isConveyanceListLoading ? (
            <>
              <IconComponent className="fa fa-spinner fa-spin" /> Loading....
            </>
          ) : (
            "Search"
          )}
        </Btn>
      </Col>
      {shouldShowAddBtn && (
        <Col xs="8" md="4" lg="3" className="mt-md-2">
          <Btn
            color={primary}
            className="mt-3 mt-md-4 f-12"
            onClick={handleAddConveyance}
          >
            {AddConveyanceLabel}
          </Btn>
        </Col>
      )}
    </Row>
  );
};

export default ConveyanceFilterBar;
